import React from "react"
import heart from '../../img/icon/heart.png';

export default function HeartRed() {
   return (
      <img src={heart} alt="" />
   )
}
